import { RouteConfig } from 'vue-router'

export const PROCESSING_PATH = '/processing'
export const PROCESSING_NAME = 'ProcessingView'

export const processingRoutesConfig: RouteConfig[] = [
  {
    path: PROCESSING_PATH,
    name: PROCESSING_NAME,
    component: () => import('@/features/processing/views/Processing.vue')
  }
]
